import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import SavingsCalculator from '../components/SavingsCalculator';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const ROICalculatorPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      
      <main className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          {/* Page Header */}
          <div className="text-center mb-10">
            <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
              Data Cleaning ROI Calculator
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              See exactly how much time and money you'll save by automating your data cleaning process.
            </p>
          </div>

          {/* Calculator */}
          <SavingsCalculator 
            onGetStarted={() => navigate('/signup')}
          />

          {/* Additional Info */}
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl p-6 border border-slate-200 text-center">
              <div className="text-3xl font-bold text-indigo-600 mb-2">1 credit = 1 row</div>
              <p className="text-slate-600 text-sm">Simple, transparent pricing</p>
            </div>
            <div className="bg-white rounded-xl p-6 border border-slate-200 text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-2">100 Free</div>
              <p className="text-slate-600 text-sm">Credits on signup, no card required</p>
            </div>
            <div className="bg-white rounded-xl p-6 border border-slate-200 text-center">
              <div className="text-3xl font-bold text-amber-600 mb-2">5 Minutes</div>
              <p className="text-slate-600 text-sm">Clean 25K rows in under 5 min</p>
            </div>
          </div>

          {/* CTA Section */}
          <div className="mt-12 text-center">
            <p className="text-slate-600 mb-6">
              Ready to stop wasting hours on manual data work?
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/signup">
                <Button className="h-12 px-8 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full">
                  Start Free
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
              <Link to="/pricing">
                <Button variant="outline" className="h-12 px-8 rounded-full">
                  View Pricing
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ROICalculatorPage;
